import selectUsualMinigame from "./SelectTask/selectUsualMinigame";
import getMinigameByName from "./getMinigameByName";

function selectMinigame(config, state, history){
    var task;
    let countArr = [1, 2, 5, 10, 20, 30];
    let count = state.objects.count ? state.objects.count : 0;
    let limit = count + config.initMinigames.length + history.filter(elem => elem.minigame.name === "final" || elem.minigame.name === "count-rest").length;
    if(!state.objects.init){
        if(history.length === config.initMinigames.length){
            state.objects.difficulty = history[3].playerAns;
            state.objects.mode = history[2].playerAns;
            state.objects.count = countArr[history[4].playerAns];
            state.objects.curcount = countArr[history[4].playerAns];
            state.objects.help = history[1].playerAns;
            state.objects.init = true;
        }
    }

    if(history.length !== 0 && history[history.length - 1].minigame.name === 'final'){
        if(history[history.length - 1].playerAns === 0) {
            state.objects.endofRound = true;
            return config.service[1];
        }
        else {
            state.objects.endofGame = true;
            return config.service[2];
        }

    }
    else if(history.length !== 0 && history[history.length - 1].minigame.name === 'count-rest'){
        if(state.objects.endofRound){
            state.objects.endofRound = false;
            state.objects.count += countArr[history[history.length - 1].playerAns];
            state.objects.curcount = countArr[history[history.length - 1].playerAns];
        }
    }
    else if(state.objects.init && history.length >= limit && !state.objects.endofRound) {
        return config.service[0];
    } 
    
    if(state.objects.init){
        task = selectUsualMinigame(config, state, history);
    }
    else {
        task = config.initMinigames.map(mg => mg.name)[history.length];
    }

    if(task === undefined){
        return undefined;
    }

    if(config.type === "menu" && task === state.objects.currentMinigame){
        return undefined;
    }

    let minigame = getMinigameByName(task, config);

    if(minigame === undefined && config.type === "menu"){
        minigame = getMinigameByName(config.minigames[0].name, config)
    }

    return minigame;
}

export default selectMinigame